module.exports = __webpack_public_path__ + "static/media/logo.d1899d9e.svg";